module.exports = __webpack_public_path__ + "img/Elephant.6b089f26.png";